/* eslint-disable import/no-extraneous-dependencies */
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  persistStore,
}
  from 'redux-persist/';
import rootReducer from './rootReducer';
import { swizzleApi } from '../services/api';
import swizzleUserApiErrorHandler from '../services/api/errorHandler';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['cart', 'dineInCart'], // only cart will be saved
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
    },
  }).concat(swizzleApi.middleware)
    .concat(swizzleUserApiErrorHandler),
});

export const persistor = persistStore(store);
